$(document).ready(() => {
    $('#add-participant').click(function() {
        var currentCount = $('.form-participant').length;
        var template = $('form > #collection-participant > .card-body > fieldset > #template-participant').data('template');
        template = template.replace(/__placeholder__/g, currentCount);

        $('form > #collection-participant > .card-body > fieldset').append(template);
        return false;
    });

    $('form').on('click', '.delete-child', function(){
        var div = $(this).closest('fieldset').remove();
    });

    showElements();
    showMethod();
    showVerification();

    $('form').on('change', '#form-type', function(){
        showElements();
    });

    $('form').on('change', '#form-method', function(){
        showMethod();
    });

    $('form').on('change', '#form-payLater', function(){
        showVerification();
    });

    function showElements() {
        if($('#form-type').val() == 'institution') {
            $('#form-institution').removeClass('d-none');
            $('#form-individual').addClass('d-none');
        } else {
            $('#form-institution').addClass('d-none');
            $('#form-individual').removeClass('d-none');
        }
    }

    function showMethod() {
        if($('#form-method').val() == 'Virement') {
            $('#method-virement').removeClass('d-none');
        } else {
            $('#method-virement').addClass('d-none');
        }
    }

    function showVerification() {
        console.log('showVerif');
        if($('#form-payLater').val() == 'later') {
            $('#form-verification').removeClass('d-none');
        } else {
            $('#form-verification').addClass('d-none');
        }
    }
});
